import React from "react";
import { useLocation } from "react-router-dom";
import { Phone, Mail, Pin, Facebook, Instagram, Telegram, Whatsapp } from "./icons";

const Card = ({ label, children }) => (
  <span className="pay-card" aria-label={label}>
    {children}
  </span>
);

export const Footer = ({ data, brand }) => {
  const year = new Date().getFullYear();
  const onHomePage = useLocation().pathname === "/";
  // Les ancres (#section) ne fonctionnent que sur l'accueil : ailleurs, on
  // repasse par "/" pour y revenir avant de sauter à la section.
  const toHref = (href) => (href.startsWith("#") && !onHomePage ? `/${href}` : href);

  return (
    <footer className="footer">
      <div className="container footer-grid">
        <div className="footer-brand">
          <div className="brand">
            <span className="brand-mark" aria-hidden="true">
              <svg viewBox="0 0 40 46" width="32" height="37">
                <path
                  d="M20 1.5 38 8v14.5C38 33 30.4 41.6 20 44.5 9.6 41.6 2 33 2 22.5V8L20 1.5z"
                  fill="none"
                  stroke="#ea88ac"
                  strokeWidth="2.4"
                />
                <text
                  x="20"
                  y="29"
                  textAnchor="middle"
                  fontFamily="Poppins, sans-serif"
                  fontSize="20"
                  fontWeight="700"
                  fill="#ea88ac"
                >
                  S
                </text>
              </svg>
            </span>
            <span className="brand-text">
              <strong>{brand?.name}</strong>
              <em>{brand?.tagline}</em>
            </span>
          </div>

          <p className="footer-about">
            {(data?.about || []).map((line) => (
              <React.Fragment key={line}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </p>

          <div className="footer-social">
            {brand?.facebookLink && (
              <a href={brand.facebookLink} aria-label="Facebook" target="_blank" rel="noreferrer">
                <Facebook size={17} />
              </a>
            )}
            {brand?.instagramLink && (
              <a href={brand.instagramLink} aria-label="Instagram" target="_blank" rel="noreferrer">
                <Instagram size={17} />
              </a>
            )}
            {brand?.telegramLink && (
              <a href={brand.telegramLink} aria-label="Telegram" target="_blank" rel="noreferrer">
                <Telegram size={17} />
              </a>
            )}
            <a
              href={brand?.whatsappLink || `https://wa.me/${(brand?.phoneLink || "").replace("+", "")}`}
              aria-label="WhatsApp"
              target="_blank"
              rel="noreferrer"
            >
              <Whatsapp size={17} />
            </a>
          </div>
        </div>

        <div className="footer-col">
          <h4>Liens rapides</h4>
          <ul className="footer-links">
            {(data?.links || []).map((l) => (
              <li key={l.label}>
                <a href={toHref(l.href)}>{l.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer-col">
          <h4>Contact</h4>
          <ul className="footer-contact">
            <li>
              <Phone size={16} />
              <a href={`tel:${brand?.phoneLink || ""}`}>{brand?.phone}</a>
            </li>
            <li>
              <Mail size={16} />
              <a href={`mailto:${brand?.email || ""}`}>{brand?.email}</a>
            </li>
            <li>
              <Pin size={16} />
              <span>{brand?.availabilityLong}</span>
            </li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Paiement accepté</h4>
          <div className="footer-pay">
            <Card label="Visa">VISA</Card>
            <Card label="Mastercard">
              <i className="mc mc-a" />
              <i className="mc mc-b" />
            </Card>
            <Card label="Carte Bleue">CB</Card>
          </div>
          <a href={toHref("#contact")} className="btn btn-primary btn-block">
            Demander un devis
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <span>
            © {year} {brand?.name}. Tous droits réservés.
          </span>
          <ul>
            {(data?.legal || []).map((l) => (
              <li key={l.label}>
                <a href={toHref(l.href)}>{l.label}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
